import baseDataForm from './baseDataForm';
import coreDataForm from './coreDataForm';
import diagnosisDataForm from './diagnosisDataForm';
import phoneDataForm from './phoneDataForm';
import outcomeOfConsultationForm from './outcomeOfConsultationForm';
import contactForm from './contactForm';
import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const clientForms: Form<Client>[] = [
  baseDataForm,
  coreDataForm,
  diagnosisDataForm,
  phoneDataForm,
  outcomeOfConsultationForm,
  contactForm,
];

export default clientForms;
